import Component from "../../components/ChatAttachmentModal/ChatAttachmentModal";
import {useContext, useRef, useState} from "preact/hooks";
import {NavigationContext} from "../../contexts/NavigationContext";
import {sendAttachment} from "../../api";
import {GlobalContext} from "../../contexts/GlobalContext";

const ChatAttachmentModal = ({onClose}) => {
  const navigation = useContext(NavigationContext);
  const { user, organization } = useContext(GlobalContext);
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const inputRef = useRef(null);

  const upload = (file) => {
    setError('');
    setFile(file);
    const { roomId, contactInternalId } = navigation.route.params;
    sendAttachment({
      roomId,
      contactInternalId,
      senderInternalId: user.internalId,
      organizationId: organization.id,
      file,
    }, {
      onUploadProgress: evt => {
        setUploadProgress(evt.loaded);
      }
    })
    .then(onClose)
    .catch(err => {
      setFile(null);
      setError("Ocorreu um erro ao enviar o arquivo.");
      if (err.response && err.response.status === 413)
          setError("O arquivo que você tentou enviar é grande demais. O tamanho máximo para anexos é 10MB.");

      if (window.Sentry) {
        window.Sentry.captureException(err);
      }
    });
  };

  const onSelectFile = evt => {
    upload(evt.target.files[0]);
  };

  const onDialog = () => {
    inputRef.current.click();
  };

  const onDragOver = evt => {
    evt.preventDefault();
    evt.stopPropagation();
  };

  const onDrop = evt => {
    evt.preventDefault();
    if (evt.dataTransfer && evt.dataTransfer.files.length !== 0) {
      const files = evt.dataTransfer.files;
      if (files.length > 1) {
        setError("Você só pode anexar um arquivo por vez.");
        return;
      }
      upload(files[0]);
    }
  };

  const filename = file && file.name;
  return <Component
    onClose={onClose}
    onDrop={onDrop}
    onDragOver={onDragOver}
    onDialog={onDialog}
    inputRef={inputRef}
    onSelectFile={onSelectFile}
    isUploading={Boolean(filename)}
    error={error}
    fileName={filename}
    uploadMax={file ? file.size : 100}
    uploadProgress={uploadProgress}
  />
};

export default ChatAttachmentModal;



// WEBPACK FOOTER //
// ./containers/ChatAttachmentModal/ChatAttachmentModal.js